module.exports = __webpack_public_path__ + "static/media/saving-account.6a00726f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/saving-account.svg
// module id = 3074
// module chunks = 0